import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode
} from "react"

const AI_HUB_CUSTOMER_KEY = "ai-hub-customer-id"

type AiHubCtx = {
  customerId: string
  setCustomerId: (id: string) => void
}

const AiHubContext = createContext<AiHubCtx>({
  customerId: "",
  setCustomerId: () => {}
})

export function AiHubContextProvider({ children }: { children: ReactNode }) {
  const [customerId, setCustomerIdState] = useState<string>(() => {
    try {
      return localStorage.getItem(AI_HUB_CUSTOMER_KEY) || ""
    } catch {
      return ""
    }
  })

  const setCustomerId = useCallback((id: string) => {
    setCustomerIdState(id)
    try {
      if (id) localStorage.setItem(AI_HUB_CUSTOMER_KEY, id)
      else localStorage.removeItem(AI_HUB_CUSTOMER_KEY)
    } catch {
      // ignore
    }
  }, [])

  return (
    <AiHubContext.Provider value={{ customerId, setCustomerId }}>
      {children}
    </AiHubContext.Provider>
  )
}

export const useAiHubContext = () => useContext(AiHubContext)
